import React from 'react';
import { FormattedMessage } from 'react-intl';
import { createStyles, Grid, makeStyles, Typography } from '@material-ui/core';

import { useRenderIntlMessage } from 'common/hooks/useRenderIntlMessage';

import { DurationTypes } from 'modules/services/constants/packages';

import { FieldInfo } from 'common/components/index';

import servicesMessages from 'modules/services/messages/messages';
import { IPaymentGrace } from 'modules/services/interfaces/packages';
import CheckCrossIcon from 'common/components/CheckCrossIcon/CheckCrossIcon';

const useStyles = makeStyles(() =>
  createStyles({
    gracePeriodStatus: {
      display: 'flex',
      alignItems: 'center',
    },
  }),
);

interface IProps {
  paymentGrace: IPaymentGrace;
}

const GracePeriodSectionView = ({ paymentGrace }: IProps): JSX.Element => {
  const renderIntlMessage = useRenderIntlMessage();

  const classes = useStyles();

  const {
    allow: paymentGraceAllow,
    duration: paymentGraceDuration,
    editableDurationNumber: { value: editableDurationNumber },
  } = paymentGrace;

  return (
    <>
      <Grid item xs={12} className={classes.gracePeriodStatus}>
        <Typography component="p" variant="h5">
          <FormattedMessage {...servicesMessages.paymentGracePeriodLabel} />
        </Typography>
        <CheckCrossIcon value={paymentGraceAllow} />
      </Grid>

      {paymentGraceAllow && (
        <Grid item xs={4}>
          <FieldInfo
            label={<FormattedMessage {...servicesMessages.durationLabel} />}
            description={`${editableDurationNumber} ${renderIntlMessage(
              DurationTypes.message(paymentGraceDuration),
            )}`}
          />
        </Grid>
      )}
    </>
  );
};

export default GracePeriodSectionView;
